import { Box, styled, Typography } from '@mui/material';
import MuiAccordionDetails from '@mui/material/AccordionDetails';

export const CustomAccordionDetails = styled(MuiAccordionDetails)(
    ({ theme }) => ({
        padding: theme.spacing(2),
        height: '400px',
        maxHeight: '400px',
        overflow: 'hidden',
    })
);

export const CustomAccordionDetailsTitleText = styled(Typography)({
    fontSize: 25,
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'normal',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
});

export const CustomAccordionDetailsDescriptionText = styled(Typography)({
    fontSize: 17,
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'normal',
});

export const CustomAccordionDetailsDivider = styled(Box)(({ theme }) => ({
    marginLeft: -16,
    width: 'calc(100% + 16px)',
    height: 1,
    backgroundColor: theme.palette.primary.main,
}));

export const CustomAccordionDetailsGridText = styled(Typography)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    lineHeight: 'normal',
});
